export default __webpack_public_path__ + "static/media/project3.a40e2f0a.png";